import { Controller } from "@hotwired/stimulus"

// data-controller="llm-models"
//   data-llm-models-url-value="/staff/settings/llm_models"
//   data-llm-models-provider-value="google"
//
//   <select data-llm-models-target="select"></select>
//   <button data-llm-models-target="button" data-action="llm-models#refresh"></button>
//   <p data-llm-models-target="status" hidden></p>
//
// Calls the staff endpoint that proxies the provider's models.list, and
// repopulates the select with the live result. Preserves the previously
// selected value if it still exists in the new list.
export default class extends Controller {
  static targets = ["select", "button", "status"]
  static values = {
    url: String,
    provider: String
  }

  async refresh(event) {
    event?.preventDefault()
    this.#showStatus("Fetching models…")
    this.buttonTarget.disabled = true

    try {
      const response = await fetch(`${this.urlValue}?provider=${encodeURIComponent(this.providerValue)}`, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })

      const raw = await response.text()
      let payload
      try {
        payload = raw ? JSON.parse(raw) : {}
      } catch {
        this.#showStatus(
          response.ok
            ? "Server returned a non-JSON response. Check the Rails log."
            : `${response.status} from server (non-JSON). Check the Rails log.`,
          true
        )
        return
      }

      if (!response.ok) {
        this.#showStatus(payload.error || `Couldn't reach the provider (HTTP ${response.status}).`, true)
        return
      }
      const models = payload.models || []
      if (models.length === 0) {
        this.#showStatus("No chat-capable models returned.", true)
        return
      }

      this.#repopulate(models)
      this.#showStatus(`${models.length} model${models.length === 1 ? "" : "s"} loaded.`)
    } catch (e) {
      this.#showStatus(`Network error: ${e.message}`, true)
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  #repopulate(models) {
    const select = this.selectTarget
    const previous = select.value
    select.innerHTML = ""
    let found = false
    for (const m of models) {
      const opt = document.createElement("option")
      opt.value = m.id
      opt.textContent = m.display_name || m.id
      if (m.id === previous) {
        opt.selected = true
        found = true
      }
      select.appendChild(opt)
    }
    if (!found && models[0]) {
      select.value = models[0].id
    }
  }

  #showStatus(text, isError = false) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = false
    this.statusTarget.textContent = text
    this.statusTarget.classList.toggle("text-brand-ink", !isError)
    this.statusTarget.classList.toggle("text-brand-muted", !isError)
  }
}
